import { useChatStatus, useDataPart } from '@ai-sdk-tools/store';
import { useFeatureFlag } from '@newfront-insurance/admin-ui';

/**
 * Hook that determines whether the ProgressDataPart component should be shown.
 *
 * ProgressDataPart is shown when:
 * - The 'nova-progress-message' feature flag is enabled
 * - There is progress data available
 * - The chat status is 'streaming'
 * - The data is not marked for clearing (data.clear is not true)
 *
 * @returns boolean indicating whether ProgressDataPart should be rendered
 */
export function useShowProgressDataPart() {
  const status = useChatStatus();
  const [data] = useDataPart("progress");
  const isProgressMessageEnabled = useFeatureFlag("nova-progress-message", false);
  return isProgressMessageEnabled && !!data?.message && status === "streaming" && !data?.clear;
}